import { Modal, Button } from 'react-bootstrap';
import { FaCircleCheck, FaCircleExclamation } from "react-icons/fa6";
import "./resultModal.css"

const ResultModal = ({
    isModalOpen,
    closeModal,
    variant = 'success',
    title = 'Registration Received',
    message,
}) => {
    const isError = variant === 'error';

    return (
        <Modal
            show={isModalOpen}
            onHide={closeModal}
            centered
            backdrop="static"
        >
            <Modal.Header>
                <Modal.Title>
                    {isError
                        ? <FaCircleExclamation className='success-icon red' />
                        : <FaCircleCheck className='success-icon' />}
                    {title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {message}
            </Modal.Body>
            <Modal.Footer>
                <Button variant={isError ? 'danger' : 'success'} onClick={closeModal}>
                    OK
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ResultModal;
